import type { RouterNavigateOptions } from "@remix-run/router/router.ts";
import { urls } from "@selector/shared";

import { router } from "@/tools.ts";

import { ENTITY_TYPE, SEQUENCE_TYPE } from "../settings/settings.ts";

export function pushRoute(path: string, options?: RouterNavigateOptions) {
  void router()?.navigate(path, options);
}

// prepared to replace BrowserTab.createUrl, needed to open in a new tab
export function routeWithBasename(route: string): string {
  // Create the url based on the config and route
  const baseUrl: string =
    location.origin + (urls.basePath === "/" ? "" : urls.basePath.substring(0, urls.basePath.length - 1));
  // is it better to use document.baseURI.replace(/\/$/, "")) + route ?
  return baseUrl + route;
}

// needed wherever we use window.location.pathname directly for example to compare with matchPath
function routeWithoutBasename(route: string): string {
  return route?.replace(urls.basePath, "/");
}

export function getCurrentRouteWithoutBasename(): string {
  return routeWithoutBasename(window.location.pathname);
}

export function mapSequenceTypeToEntityType(type: string): string {
  switch (type) {
    case SEQUENCE_TYPE.GENOMIC:
      return ENTITY_TYPE.CONTIG;
    case SEQUENCE_TYPE.TRANSCRIPT:
      return ENTITY_TYPE.TRANSCRIPT;
    case SEQUENCE_TYPE.PROTEIN:
      return ENTITY_TYPE.PROTEIN;
    case SEQUENCE_TYPE.PROBE:
      return ENTITY_TYPE.PROBE;
    case SEQUENCE_TYPE.OTHER_DNA_RNA:
      return ENTITY_TYPE.OTHER;
  }

  return ENTITY_TYPE.SEQUENCE;
}
